module.exports = __webpack_public_path__ + "static/lifewheel-red-df6d9e492d0666bd40cd2adb98d80aa0.png";